import type { PostableWithExtras } from "./types";

export function getPostableImage(postable: PostableWithExtras): string {
  // Try to get image from different possible sources based on postable type
  if (postable.postableType === "basicPost") {
    // Prioritize the displayImage from json
    if (postable.json?.displayImage) {
      return postable.json.displayImage as string;
    }

    // Fallback to other image sources
    return (
      (postable.json?.image as string) ||
      (postable.postable.image as string) ||
      "https://placehold.co/600x400/png"
    );
  }

  if (postable.postableType === "webLink") {
    // Prioritize displayImage from json for webLinks too
    if (postable.json?.displayImage) {
      return postable.json.displayImage as string;
    }

    return (
      (postable.postable.image as string) || "https://placehold.co/600x400/png"
    );
  }

  if (postable.postableType === "event") {
    return (
      (postable.postable.imageUrl as string) ||
      "https://placehold.co/600x400/png"
    );
  }

  if (postable.postableType === "video") {
    return (
      (postable.postable.thumbnailUrl as string) ||
      "https://placehold.co/600x400/png"
    );
  }

  // Default fallback
  return "https://placehold.co/600x400/png";
}

export function getPostableTitle(postable: PostableWithExtras): string {
  // Try to get title from different possible sources based on postable type
  if (postable.postableType === "basicPost") {
    return (
      (postable.json?.displayTitle as string) ||
      (postable.postable.title as string) ||
      "Untitled"
    );
  }

  if (postable.postableType === "webLink") {
    return (
      (postable.json?.displayTitle as string) ||
      (postable.postable.fullTitle as string) ||
      (postable.postable.title as string) ||
      "Web Link"
    );
  }

  // For most postable types, we can use the title property
  return (postable.postable.title as string) || "Untitled";
}

export function getPostableUrl(postable: PostableWithExtras): string | null {
  if (postable.postableType === "webLink") {
    return (postable.postable.url as string) || null;
  }

  return null;
}
